<template>
  <div class="flag_manage" >
    <el-divider content-position="left">个人目标管理</el-divider>

    <div v-if="currentAuthId.includes(9) == true" class="box_title"
      style="margin-bottom: 0.2rem;margin-top: 0.6rem;line-height: .6rem;margin-left: 0.4rem;">
      <el-row>
        <el-col :span="2">考核人员</el-col>
        <el-col :span="4">
          <el-select v-model="searchPersonel.operator" filterable placeholder="请选择" clearable size="small">
            <el-option v-for="option in personnel" :key="option.id" :label="option.username" :value="option.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" size="small" @click="handleASearch" style="margin-left: .2rem;">查询</el-button>
        </el-col>
      </el-row>
    </div>

    <el-tabs v-model="checkCircle" type="border-card" @tab-click="handleClick" style="margin-top: 0.2rem;">

      <el-tab-pane label="日目标" name="1">
        <el-divider content-position="left">日期：{{ date }}</el-divider>
        <el-table :data="dayGoal" size="mini" border style="width: 100%; margin-top: 0.2rem" v-cloak :row-key="getRowKey">
          <el-table-column label="考核名称" width="80">
            <template slot-scope="scope">
                <span class="hide-style">{{ scope.row.check_setting.check_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="基础目标" width="80">
            <template slot-scope="scope">
              <span class="count-style">{{ scope.row.check_setting.check_goal + scope.row.check_setting.check_unit
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="当前目标值" width="80">
            <template slot-scope="scope">
              <el-input type="number" :disabled="true" v-model="scope.row.goal_value"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="设置目标值" width="80" :render-header="downOrderrenderHeader">
            <template slot-scope="scope">
              <span v-if="scope.row.check_circle === 1">
                <el-input :min="0" v-if="scope.row.check_circle === 1" :formatter="formatValue" type="number"
                  @blur="settingGoal(scope.row.check_setting.check_goal)" v-model="dayGoalValue[scope.row.id]"
                  clearable></el-input>
              </span>
              <span v-else>
                <el-input :min="0" v-if="currentAuthId.includes(9) == true" :formatter="formatValue" type="number"
                  @blur="settingGoal(scope.row.check_setting.check_goal)" v-model="dayGoalValue[scope.row.id]"
                  clearable></el-input>
                <template v-else>
                  <el-input :min="0" :disabled="true" :formatter="formatValue" type="number"
                    @blur="settingGoal(scope.row.check_setting.check_goal)" v-model="dayGoalValue[scope.row.id]"
                    clearable></el-input>
                </template>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="周目标" name="2">
        <el-divider content-position="left">日期：{{ date }}</el-divider>
        <el-table :data="dayGoal" size="mini" border style="width: 100%; margin-top: 0.2rem" v-cloak :row-key="getRowKey">
          <el-table-column label="考核名称" width="80">
            <template slot-scope="scope">
                <span class="hide-style">{{ scope.row.check_setting.check_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="基础目标" width="80">
            <template slot-scope="scope">
              <span class="count-style">{{ scope.row.check_setting.check_goal + scope.row.check_setting.check_unit
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="当前目标值" width="80">
            <template slot-scope="scope">
              <el-input type="number" :disabled="true" v-model="scope.row.goal_value"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="设置目标值" width="80" :render-header="downOrderrenderHeader">
            <template slot-scope="scope">
              <span v-if="scope.row.check_circle === 1">
                <el-input :min="0" v-if="scope.row.check_circle === 1" :formatter="formatValue" type="number"
                  @blur="settingGoal(scope.row.check_setting.check_goal)" v-model="dayGoalValue[scope.row.id]"
                  clearable></el-input>
              </span>
              <span v-else>
                <el-input :min="0" v-if="currentAuthId.includes(9) == true" :formatter="formatValue" type="number"
                  @blur="settingGoal(scope.row.check_setting.check_goal)" v-model="dayGoalValue[scope.row.id]"
                  clearable></el-input>
                <template v-else>
                  <el-input :min="0" :disabled="true" :formatter="formatValue" type="number"
                    @blur="settingGoal(scope.row.check_setting.check_goal)" v-model="dayGoalValue[scope.row.id]"
                    clearable></el-input>
                </template>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="月目标" name="3">
        <el-divider content-position="left">日期：{{ date }}</el-divider>
        <el-table :data="dayGoal" size="mini" border style="width: 100%; margin-top: 0.2rem" v-cloak :row-key="getRowKey">
          <el-table-column label="考核名称" width="80">
            <template slot-scope="scope">
                <span class="hide-style">{{ scope.row.check_setting.check_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="基础目标" width="80">
            <template slot-scope="scope">
              <span class="count-style">{{ scope.row.check_setting.check_goal + scope.row.check_setting.check_unit
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="当前目标值" width="80">
            <template slot-scope="scope">
              <el-input type="number" :disabled="true" v-model="scope.row.goal_value"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="设置目标值" width="80" :render-header="downOrderrenderHeader">
            <template slot-scope="scope">
              <span v-if="scope.row.check_circle === 1">
                <el-input :min="0" v-if="scope.row.check_circle === 1" :formatter="formatValue" type="number"
                  @blur="settingGoal(scope.row.check_setting.check_goal)" v-model="dayGoalValue[scope.row.id]"
                  clearable></el-input>
              </span>
              <span v-else>
                <el-input :min="0" v-if="currentAuthId.includes(9) == true" :formatter="formatValue" type="number"
                  @blur="settingGoal(scope.row.check_setting.check_goal)" v-model="dayGoalValue[scope.row.id]"
                  clearable></el-input>
                <template v-else>
                  <el-input :min="0" :disabled="true" :formatter="formatValue" type="number"
                    @blur="settingGoal(scope.row.check_setting.check_goal)" v-model="dayGoalValue[scope.row.id]"
                    clearable></el-input>
                </template>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="年目标" name="4">
        <el-divider content-position="left">日期：{{ date }}</el-divider>
        <el-table :data="dayGoal" size="mini" border style="width: 100%; margin-top: 0.2rem" v-cloak :row-key="getRowKey">
          <el-table-column label="考核名称" width="80">
            <template slot-scope="scope">
                <span class="hide-style">{{ scope.row.check_setting.check_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="基础目标" width="80">
            <template slot-scope="scope">
              <span class="count-style">{{ scope.row.check_setting.check_goal + scope.row.check_setting.check_unit
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="当前目标值" width="80">
            <template slot-scope="scope">
              <el-input type="number" :disabled="true" v-model="scope.row.goal_value"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="设置目标值" width="80" :render-header="downOrderrenderHeader">
            <template slot-scope="scope">
              <span v-if="scope.row.check_circle === 1">
                <el-input :min="0" v-if="scope.row.check_circle === 1" :formatter="formatValue" type="number"
                  @blur="settingGoal(scope.row.check_setting.check_goal)" v-model="dayGoalValue[scope.row.id]"
                  clearable></el-input>
              </span>
              <span v-else>
                <el-input :min="0" v-if="currentAuthId.includes(9) == true" :formatter="formatValue" type="number"
                  @blur="settingGoal(scope.row.check_setting.check_goal)" v-model="dayGoalValue[scope.row.id]"
                  clearable></el-input>
                <template v-else>
                  <el-input :min="0" :disabled="true" :formatter="formatValue" type="number"
                    @blur="settingGoal(scope.row.check_setting.check_goal)" v-model="dayGoalValue[scope.row.id]"
                    clearable></el-input>
                </template>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>

export default {
  name: 'PersonGoal',
  data() {
    return {
      currentAuthId: [],
      personnel: [],
      searchPersonel: {
        operator: null
      },
      checkCircle: "1",
      date: '',
      dayGoal: [],
      dayGoalValue: []
    }
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === 'development'
          ? ''
          : 'https://weixin.qiyehuo.com'
      }
    },
    collapse() {
      return this.$store.state.collapse
    }
  },
  watch: {},
  methods: {
    loadGoalData() {
      this.$axios.post('api/admin/edit/get_user_check_goal', {
        checkUser: this.searchPersonel,
        checkCircle: this.checkCircle
      }).then(({ data }) => {
        if (data.code === 0) {
          this.personnel = data.data.personnel
          this.date = data.data.showDate
          this.currentAuthId = data.data.roleAuth
          this.dayGoal = data.data.hasCheckSetting   // 目标数据
        }
      }).catch()
    },
    settingGoal(standard) {
      this.$axios.post('api/admin/edit/user_check_goal', {
        standard: standard,
        goalVal: this.dayGoalValue
      }).then(({ data }) => {
        if (data.code === 0) {
          this.dayGoalValue = []
          this.loadGoalData()
          this.$message.success(data.msg)
        } else {
          this.dayGoalValue = []
          this.$message.error(data.msg)
        }
      }).catch()
    },
    handleASearch() {
      this.loadGoalData()
    },
    handleClick(tab) {
      // 监听点击事件
      if (parseInt(tab.index) === 0) {
        // 日目标
        this.checkCircle = "1"
        this.loadGoalData()
      } else if (parseInt(tab.index) === 1) {
        // 周目标
        this.checkCircle = "2"
        this.loadGoalData()
      } else if (parseInt(tab.index) === 2) {
        // 月目标
        this.checkCircle = "3"
        this.loadGoalData()
      } else if (parseInt(tab.index) === 3) {
        // 年目标
        this.checkCircle = "4"
        this.loadGoalData()
      }
    },
    formatValue(value) {
      if (value <= 0) {
        return 0;
      }
      return value;
    },
    downOrderrenderHeader(h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              content: (function () {
                return '目标值不可以小于基础目标'
              })(),
              placement: 'top'
            }
          },
          [
            h('span', {
              class: {
                'el-icon-question': true
              }
            })
          ]
        )
      ]
    },
    getRowKey(row) {
      return row.id;
    }
  },
  mounted() {
    this.loadGoalData()
  }
}
</script>
<style>
.is-selected {
  color: #1989fa;
}
</style>
<style scoped lang="stylus">
  @import '~styles/varibles.styl';
  @import '~styles/vertical.styl';
  @import '~styles/icon.styl';
  
  .el-drawer__wrapper >>> .el-drawer {
    overflow-y: auto;
  }
  
  .el-drawer__wrapper >>> .el-drawer__header span {
    color: #5789F4;
    font-size: 0.36rem;
    font-weight: 400;
  }
  
  .flag_manage {
    marginLeft();
  
    .count_style {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  
  .tr {
    text-align: right;
  }
  
  .m-tabs-content {
    overflow-y: auto;
    padding: 0 0.4rem;
    box-sizing: border-box;
  
    .m-label {
      line-height: 0.64rem;
    }
  
    .text_right {
      text-align: left;
    }
  
    .el-row {
      margin-bottom: 0.4rem;
    }
  }
  
  .flag_manage >>> .el-table__header th {
    color: #333333;
    background-color: #ECF4FF;
  }
  
  /* .clues_manage >>> .el-table__header thead .is-hidden */
  /* color: red */
  /* background-color: #ECF4FF */
  /* font-size 16px */
  .mb-10 {
    margin-bottom: 0.2rem;
    margin-top: 0.4rem;
  }
  
  .mt-10 {
    margin-top: 0.2rem;
  }
  
  .level {
    display: flex;
    align-items: center;
    position: relative;
    padding-right: 0.32rem;
  
    img {
      width: 0.32rem;
      height: 0.3rem;
    }
  
    .el-icon-question {
      margin-left: 0.1rem;
      color: #409EFF;
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
    }
  }
  
  .el-select, .el-cascader {
    width: 100%;
  }
  
  .count {
    padding-left: 0.2rem;
    line-height: 0.56rem;
  }
  
  .el-position {
    position: relative;
  
    .dot {
      display: inline-block;
      width: 0.1rem;
      height: 0.1rem;
      border-radius: 50%;
      margin-right: 0.1rem;
      position: absolute;
      top: 0;
      left: -0.2rem;
      bottom: 0;
      margin: auto;
    }
  }
  
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  
  .el-icon-arrow-down {
    font-size: 12px;
  }
  
  .changeHeight {
    padding: 0.2rem;
    margin-top: 0.4rem;
  }
  
  .el-collapse {
    border-bottom: 0;
    border-top: 0;
  }
  
  .el-collapse >>> .el-collapse-item__header {
    color: #4C87FC;
    font-weight: bold;
  }
  
  .el-collapse >>> .el-collapse-item__arrow {
    color: #4C87FC;
  }
  
  .el-collapse >>> .el-collapse-item__content {
    padding-bottom: 0;
  }
  
  .el_dialogs >>> .el-dialog__body {
    padding-left: 0;
    padding-right: 0;
  }
  
  .el_dialogs >>> .el-dialog__header {
    padding: 0;
  }
  
  .block {
    height: 6rem;
    overflow-y: auto;
    padding-top: 0.2rem;
    padding-left: 0.2rem;
    box-sizing: border-box;
  
    .time_right {
      width: 100%;
      margin-top: 0.4rem;
      overflow: hidden;
      word-break: break-all;
      white-space: normal;
    }
  }
  
  .el-timeline-item__node--large {
    width: 0.4rem;
    height: 0.4rem;
  }
  
  /* 滚动条整体样式 */
  ::-webkit-scrollbar {
    width: 0.1rem; /* 竖向滚动条的宽度 */
    height: 10px; /* 横向滚动条的高度 */
  }
  
  ::-webkit-scrollbar-thumb { /* 滚动条里面的小方块 */
    background: #cdcdcd;
    border-radius: 5px;
  }
  
  ::-webkit-scrollbar-track { /* 滚动条轨道的样式 */
    background: #f8f8f8;
    border-radius: 5px;
  }
  
  .el-date-editor {
    width: 100% !important;
  }
  
  .top_hint {
    height: 0.8rem;
    line-height: 0.8rem;
    background: #ECF4FF;
  
    span {
      color: #5787FF;
    }
  }
  .i-content li {
    float: left;
    margin-right: 5px;
    margin-top: 5px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/pages/data_analysis/PersonGoal.vue